import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as api from "../../../redux/api";
import CustomFileInput from "../../CustomFileInput";
import { reactIcons } from "../../../utils/icons";

const AdminKyc = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [documentTypes, setDocumentTypes] = useState({
    certificateOfIncorporation: [],
    taxCertificate: [],
    miningTradingLicense: []
  });
  const [errors, setErrors] = useState({});
  const [isKyc, setIsKyc] = useState();

  const [isReadOnly, setIsReadOnly] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { key } = location.state || {};

  useEffect(() => {
    const getData = async () => {
      if (!id) return;
      try {
        const res = await api.getUserList(id);
        if (res.status && res.data) {
          const org = res.data.data;
          const kyc = org.KYC;
          if (kyc) {
            setIsReadOnly(true);
            setIsKyc(kyc.verificationStatus);

            setDocumentTypes({
              certificateOfIncorporation:
                kyc.certificateOfIncorporation?.map((url) => ({
                  name: url.split("/").pop(),
                  url
                })) || [],
              taxCertificate:
                kyc.taxCertificate?.map((url) => ({
                  name: url.split("/").pop(),
                  url
                })) || [],
              miningTradingLicense:
                kyc.miningTradingLicense?.map((url) => ({
                  name: url.split("/").pop(),
                  url
                })) || []
            });
          }
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    getData();
  }, [id]);
  console.log("Documents: ", documentTypes);
  console.log("KYC Status: ", isKyc);

  const validate = () => {
    const newErrors = {};
    if (!documentTypes.certificateOfIncorporation.length) {
      newErrors.certificateOfIncorporation =
        "Certificate of Incorporation is required.";
    }
    if (!documentTypes.taxCertificate.length) {
      newErrors.taxCertificate = "Tax Certificate is required.";
    }
    if (!documentTypes.miningTradingLicense.length) {
      newErrors.miningTradingLicense = "Mining/Trading License is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    if (!validate()) return;
    try {
      setIsLoading(true);
      const payload = {
        organizationId: Number(id),
        certificateOfIncorporation:
          documentTypes.certificateOfIncorporation.map((doc) =>
            typeof doc === "string" ? doc : doc.url
          ),
        taxCertificate: documentTypes.taxCertificate.map((doc) =>
          typeof doc === "string" ? doc : doc.url
        ),
        miningTradingLicense: documentTypes.miningTradingLicense.map((doc) =>
          typeof doc === "string" ? doc : doc.url
        )
      };
      const res = await api.kycSubmit(payload);
      if (res.status === 200 || res.status === 201) {
        toast.success("KYC documents submitted successfully");
        setIsReadOnly(true);
        navigate(`/acknowledgment/${id}`, { state: { key } });
      } else {
        toast.error(res?.error?.message || "Submission failed");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "An error occurred while submitting the form"
      );
    } finally {
      setIsLoading(false);
    }
  };
  const updateDocuments = (name, urls) => {
    const formatted = urls.map((url) => ({
      name: url.split("/").pop(),
      url
    }));
    setDocumentTypes((prev) => ({ ...prev, [name]: formatted }));
    if (formatted.length > 0) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between pb-10">
        {/* <BackButton /> */}
        <h2 className="text-black text-24 text-center">KYC Document</h2>
        <div></div>
      </div>
      <form
        className="grid grid-cols-2 gap-4 border border-yellow-dark p-5 rounded-[10px]"
        onSubmit={(e) => {
          e.preventDefault();
          if (key) {
            handleSubmit(e);
          } else if (id) {
            navigate(`/acknowledgment/${id}`);
          } else {
            handleSubmit(e);
          }
        }}
      >
        {/* <div>
          <CustomFileInput
            label="Certificate of Incorporation"
            allowedFormats="PDF, PNG, JPG"
            name="certificateOfIncorporation"
            defaultValue={documentTypes.certificateOfIncorporation.map(
              (f) => f.url || f
            )}
            onChange={(urls) =>
              setDocumentTypes((prev) => ({
                ...prev,
                certificateOfIncorporation: urls.map((url) => ({
                  name: url.split("/").pop(),
                  url
                }))
              }))
            }
            disabled={isReadOnly}
          />
          {errors.certificateOfIncorporation && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.certificateOfIncorporation}
            </p>
          )}
        </div>
        <div>
          <CustomFileInput
            label="Tax Certificate"
            allowedFormats="PDF, PNG, JPG"
            name="taxCertificate"
            defaultValue={documentTypes.taxCertificate.map((f) => f.url || f)}
            onChange={(urls) =>
              setDocumentTypes((prev) => ({
                ...prev,
                taxCertificate: urls.map((url) => ({
                  name: url.split("/").pop(),
                  url
                }))
              }))
            }
            disabled={isReadOnly}
          />
          {errors.taxCertificate && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.taxCertificate}
            </p>
          )}
        </div>
        <div>
          <CustomFileInput
            label="Mining/Trading License"
            allowedFormats="PDF, PNG, JPG"
            name="miningTradingLicense"
            defaultValue={documentTypes.miningTradingLicense.map(
              (f) => f.url || f
            )}
            onChange={(urls) =>
              setDocumentTypes((prev) => ({
                ...prev,
                miningTradingLicense: urls.map((url) => ({
                  name: url.split("/").pop(),
                  url
                }))
              }))
            }
            disabled={isReadOnly}
          />
          {errors.miningTradingLicense && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.miningTradingLicense}
            </p>
          )}
        </div> */}
        <div>
          <CustomFileInput
            label="Certificate of Incorporation"
            allowedFormats="PDF"
            name="certificateOfIncorporation"
            defaultValue={documentTypes.certificateOfIncorporation.map(
              (f) => f.url || f
            )}
            onChange={(urls) =>
              updateDocuments("certificateOfIncorporation", urls)
            }
            disabled={isReadOnly}
          />
          {errors.certificateOfIncorporation && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.certificateOfIncorporation}
            </p>
          )}
        </div>

        <div>
          <CustomFileInput
            label="Tax Certificate"
            allowedFormats="PDF"
            name="taxCertificate"
            defaultValue={documentTypes.taxCertificate.map((f) => f.url || f)}
            onChange={(urls) => updateDocuments("taxCertificate", urls)}
            disabled={isReadOnly}
          />
          {errors.taxCertificate && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.taxCertificate}
            </p>
          )}
        </div>

        <div>
          <CustomFileInput
            label="Mining/Trading License"
            allowedFormats="PDF"
            name="miningTradingLicense"
            defaultValue={documentTypes.miningTradingLicense.map(
              (f) => f.url || f
            )}
            onChange={(urls) => updateDocuments("miningTradingLicense", urls)}
            disabled={isReadOnly}
          />
          {errors.miningTradingLicense && (
            <p className="text-red-500 text-sm col-span-2">
              {errors.miningTradingLicense}
            </p>
          )}
        </div>

        <div className="col-span-2 flex justify-between items-center">
          {" "}
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn btn-danger"
          >
            {reactIcons.arrowleft} Back
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="py-3 px-6 rounded btn-primary flex items-center"
          >
            Next {reactIcons.arrowright}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminKyc;
